export default {
  root: {
    minWidth: '30px'
  }
};